import { Component, OnInit } from '@angular/core';
import * as fromBranchChampionsAction from 'src/app/@core/ngrx/branchchampions/branchchampions.actions';
import { BranchChampionsState } from '../../@core/ngrx/branchchampions/branchchampions.state';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { RankListResponseWrapper } from 'src/app/api/models';
import {
  selectAllBranchChampionsItemsPresent,
  selectBranchChampionsByMonth,
} from 'src/app/@core/ngrx/branchchampions/branchchampions.selectors';
import { StringMap } from 'src/app/@theme/datatable/datatable.component';
import { isLoading } from 'src/app/@core/ngrx/runningaction/running-action.selectors';
import { ActivatedRoute } from '@angular/router';
import { ThemeService } from 'src/app/@core/services/theme.service';

@Component({
  selector: 'app-branchchampions-page',
  templateUrl: './branchchampions-page.component.html',
  styleUrls: ['./branchchampions-page.component.scss'],
})
export class BranchChampionsPageComponent implements OnInit {
  branchChampions$: Observable<RankListResponseWrapper[]> = new Observable();
  branch?: string;
  loading$: Observable<boolean> = of(false);
  theme: string = '';

  constructor(
    private store: Store<BranchChampionsState>,
    private activatedRoute: ActivatedRoute,
    private themeService: ThemeService,
  ) {}

  ngOnInit() {
    this.loading$ = this.store.pipe(
      select(isLoading([fromBranchChampionsAction.loadMany])),
    );

    this.branch = this.activatedRoute.snapshot.url[1].path;

    const day = String(new Date().getDate()).padStart(2, '0');
    const month = String(new Date().getMonth() + 1).padStart(2, '0');
    const year = new Date().getFullYear();
    const date = year + '-' + month + '-' + day;

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['color']) {
        this.theme = params['color'];
      } else {
        this.theme = 'light';
      }
      this.themeService.setTheme(this.theme!);
    });

    this.theme === 'dark'
      ? document.body.classList.add('dark-theme')
      : document.body.classList.add('light-theme');

    this.store.dispatch(
      fromBranchChampionsAction.loadMany({
        month: date,
        nameSpace: this.branch,
      }),
    );

    this.branchChampions$ = this.store.pipe(
      select(selectAllBranchChampionsItemsPresent),
    );
  }

  public onFilterChange(event: StringMap): void {
    const eventDate = new Date(event['month']);
    const year = eventDate.getFullYear();
    const month = String(eventDate.getMonth() + 1).padStart(2, '0');
    const day = String(new Date().getDate()).padStart(2, '0');

    const shortDate = year + '.' + month + '.';
    const longDate = year + '-' + month + '-' + day;

    this.store.dispatch(
      fromBranchChampionsAction.loadMany({
        month: longDate,
        nameSpace: this.branch!,
      }),
    );
    this.branchChampions$ = this.store.pipe(
      select(selectBranchChampionsByMonth(shortDate)),
    );
  }
}
